webpackJsonp([1],{

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Header = __webpack_require__(202);

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__(201);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "app",
  components: {
    "dap-header": _Header2.default,
    "dap-footer": _Footer2.default
  }
};

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Utils = __webpack_require__(31);

var _Utils2 = _interopRequireDefault(_Utils);

var _DivValidation = __webpack_require__(77);

var _DivValidation2 = _interopRequireDefault(_DivValidation);

var _BasicoService = __webpack_require__(58);

var _BasicoService2 = _interopRequireDefault(_BasicoService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    "div-vali": _DivValidation2.default
  },
  data: function data() {
    return {
      loading: true,
      total: 0,
      obj: null,
      list: [],
      addEditTitle: "הוספת פרויקט חדש"
    };
  },

  methods: {
    callList: function callList() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.loading = true;
      var basicoService = new _BasicoService2.default(this);
      basicoService.categoryList(page).then(function (list) {
        if (list) {
          _this.total = list.data.total;
          _this.list = list.data.data;
        }
        _this.loading = false;
      });
    },
    save: function save() {
      var _this2 = this;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          var basicoService = new _BasicoService2.default(_this2);
          basicoService.categorySave(_this2.obj).then(function (res) {
            if (res) {
              _Utils2.default.showMessage("פרויקט נשמר", "success");
            } else {}
            _this2.cancel();
          });
        }
      });
    },
    remove: function remove(id) {
      var _this3 = this;

      if (confirm("בטוח להסיר?")) {
        var basicoService = new _BasicoService2.default(this);
        basicoService.categoryDelete(id).then(function (res) {
          if (res) {
            _Utils2.default.showMessage("פרויקט נמחק", "success");
          } else {}
          _this3.cancel();
        });
      }
    },
    add: function add(obj) {
      this.obj = obj;
      this.addEditTitle = 'הוספת פרויקט חדש';
    },
    edit: function edit(obj) {
      this.obj = obj;
      this.addEditTitle = 'עריכת פרויקט קיים';
    },
    cancel: function cancel() {
      this.obj = null;
      this.callList();
    }
  },
  created: function created() {
    this.callList();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _main = __webpack_require__(30);

exports.default = {
  data: function data() {
    return {
      auth: _main.auth,
      login: null,
      password: null
    };
  },

  methods: {
    signin: function signin() {
      _main.auth.signin(this.login, this.password);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
exports.default = {
  components: {},
  created: function created() {},
  data: function data() {
    return {};
  },

  methods: {},
  watch: {}
};

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _Utils = __webpack_require__(31);

var _Utils2 = _interopRequireDefault(_Utils);

var _DivValidation = __webpack_require__(77);

var _DivValidation2 = _interopRequireDefault(_DivValidation);

var _BasicoService = __webpack_require__(58);

var _BasicoService2 = _interopRequireDefault(_BasicoService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    "div-vali": _DivValidation2.default
  },
  data: function data() {
    return {
      api: '',
      search: '',
      loading: true,
      total: 0,
      id: null,
      category: {},
      obj: null,
      file: null,
      list: [],
      addEditTitle: 'הוספת סרטון חדש'
    };
  },

  methods: {
    getFileRequired: function getFileRequired() {
      return this.obj && this.obj.id == 0 ? 'required' : '';
    },
    getFilename: function getFilename(name, type) {
      var filename = name;
      if (type == 'docx') {
        filename += '_w.docx';
      } else if (type == 'odt') {
        filename += '_o.odt';
      } else if (type == 'txtsrt') {
        filename += '.txt';
      } else if (type == 'txtspk') {
        filename += '.txt';
      } else {
        filename += '.' + type;
      }
      return filename;
    },
    getMime: function getMime(type) {
      switch (type) {
        case 'docx':
        case 'odt':
          return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=ANSI';
        case 'txt':
        case 'txtspk':
          return 'text/plain;charset=Windows-1255';
        case 'srt':
          return 'text/plain;charset=UTF-8';
        case 'txtsrt':
          return 'text/plain;charset=UTF-8-BOM';
        default:
          return '';
      }
    },
    downloadJson: function downloadJson(id, name, type) {
      var _this = this;

      var basicoService = new _BasicoService2.default(this);
      basicoService.videoExport(id, type).then(function (response) {
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([response.data], { type: _this.getMime(type) }));
        link.setAttribute('download', _this.getFilename(name, type));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    handleFileUpload: function handleFileUpload() {
      this.file = this.$refs.file.files[0];
      var temp = this.file.name.split('.');
      if (temp.length > 1) {
        temp.pop();
      }
      this.obj.name = temp.join('.');
      if (this.file) {
        var reader = new FileReader();
        reader.readAsText(this.file);
        reader.onload = this.onJsonFinishLoad;
      }
    },
    onJsonFinishLoad: function onJsonFinishLoad(evt) {
      var speakers = [];
      var fileJson = JSON.parse(evt.target.result);
      fileJson.settings.channels.forEach(function (channel) {
        channel.speaker.forEach(function (speaker) {
          speakers.push(speaker);
        });
      });
      this.obj.interviewer = speakers.join(', ');
    },
    callCategory: function callCategory() {
      var _this2 = this;

      var basicoService = new _BasicoService2.default(this);
      basicoService.category(this.id).then(function (category) {
        if (category) {
          _this2.category = category.data;
        }
      });
    },
    callList: function callList() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.loading = true;
      var basicoService = new _BasicoService2.default(this);
      basicoService.videoList(this.id, this.search, page).then(function (list) {
        if (list) {
          _this3.total = list.data.total;
          _this3.list = list.data.data;
        }
        _this3.loading = false;
      });
    },
    save: function save() {
      var _this4 = this;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          var data = new FormData();
          data.append('id', _this4.obj.id);
          data.append('name', _this4.obj.name);
          data.append('interviewer', _this4.obj.interviewer);
          data.append('category_id', _this4.id);
          if (_this4.file) {
            data.append('file', _this4.file);
          }
          var basicoService = new _BasicoService2.default(_this4);
          basicoService.videoSave(_this4.obj.id, data).then(function (res) {
            if (res) {
              _Utils2.default.showMessage("סרטון נשמר", "success");
            } else {}
            _this4.cancel();
          });
        }
      });
    },
    remove: function remove(id) {
      var _this5 = this;

      if (confirm("בטוח להסיר?")) {
        var basicoService = new _BasicoService2.default(this);
        basicoService.videoDelete(id).then(function (res) {
          if (res) {
            _Utils2.default.showMessage("סרטון הוסר בהצלחה", "success");
          } else {}
          _this5.cancel();
        });
      }
    },
    add: function add(obj) {
      this.obj = obj;
      this.addEditTitle = 'הוספת סרטון חדש';
    },
    edit: function edit(obj) {
      this.obj = obj;
      this.addEditTitle = 'עריכת סרטון קיים';
    },
    cancel: function cancel() {
      this.file = null;
      this.obj = null;
      this.callList();
    }
  },
  created: function created() {
    this.api = "//ocdpost.metatron.co.il/index.php/api/";
    this.id = this.$route.params.id;
    this.search = '';
    this.callCategory();
    this.callList();
  }
};

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {};
  }
};

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _main = __webpack_require__(30);

exports.default = {
  data: function data() {
    return {
      auth: _main.auth
    };
  },

  methods: {
    signout: function signout() {
      _main.auth.signout("Logged out", "success");
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      _main.auth.check();
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//

exports.default = {
    props: {
        errorVee: {
            required: true
        },
        hasFormGroup: {
            type: Boolean,
            default: true
        },
        labelTxt: {
            type: String
        },
        errorMsg: {
            type: String,
            default: 'Campo obrigatório'
        }
    },
    methods: {
        getClassValue: function getClassValue() {
            var cl = '';
            if (this.hasFormGroup) {
                cl += ' form-group';
            }
            if (this.errorVee) {
                cl += ' has-error';
            }
            return cl;
        }
    }
};

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DomainParent2 = __webpack_require__(122);

var _DomainParent3 = _interopRequireDefault(_DomainParent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var User = function (_DomainParent) {
    _inherits(User, _DomainParent);

    function User(userInfo) {
        _classCallCheck(this, User);

        var _this = _possibleConstructorReturn(this, (User.__proto__ || Object.getPrototypeOf(User)).call(this));

        _this._id = userInfo.id;
        _this._nome = userInfo.name;
        return _this;
    }

    _createClass(User, [{
        key: 'nome',
        get: function get() {
            return this._nome;
        }
    }]);

    return User;
}(_DomainParent3.default);

exports.default = User;

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DomainParent = function () {
    function DomainParent() {
        _classCallCheck(this, DomainParent);
    }

    _createClass(DomainParent, [{
        key: 'hasId',
        value: function hasId() {
            return this.id != null && this.id != '' && this.id > 0;
        }
    }]);

    return DomainParent;
}();

exports.default = DomainParent;

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__(54);

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InfoService = function () {
  function InfoService() {
    var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, InfoService);

    this._http = _vue2.default.http;
    this._ref = ref;
  }

  _createClass(InfoService, [{
    key: 'errorHandler',
    value: function errorHandler(err) {
      if (err.status == 401) {
        _router2.default.push({ path: '/login' });
      } else {
        if (this._ref) {
          this._ref.$message.error(err.data.errors);
        }
        return false;
      }
    }
  }, {
    key: 'customGet',
    value: function customGet(url) {
      var _this = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var contentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'application/json';

      return this._http.get(url, { params: params }, { headers: { 'Content-Type': contentType } }).then(function (res) {
        if (res.ok) {
          return res;
        } else {
          return false;
        }
      }, function (err) {
        return _this.errorHandler(err);
      });
    }
  }, {
    key: 'customGetDownload',
    value: function customGetDownload(url) {
      var _this2 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var contentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'application/json';

      return this._http.get(url, { params: params, responseType: 'arraybuffer' }, { headers: { 'Content-Type': contentType }, responseType: 'arraybuffer' }).then(function (res) {
        if (res.ok) {
          return res;
        } else {
          return false;
        }
      }, function (err) {
        return _this2.errorHandler(err);
      });
    }
  }, {
    key: 'customPost',
    value: function customPost(url) {
      var _this3 = this;

      var dto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var contentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'application/json';

      return this._http.post(url, dto, { headers: { 'Content-Type': contentType } }).then(function (res) {
        if (res.ok) {
          return res;
        } else {
          return false;
        }
      }, function (err) {
        return _this3.errorHandler(err);
      });
    }
  }, {
    key: 'customPut',
    value: function customPut(url) {
      var _this4 = this;

      var dto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var contentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'application/json';

      return this._http.put(url, dto, { headers: { 'Content-Type': contentType } }).then(function (res) {
        if (res.ok) {
          return res;
        } else {
          return false;
        }
      }, function (err) {
        return _this4.errorHandler(err);
      });
    }
  }, {
    key: 'customPatch',
    value: function customPatch(url) {
      var _this5 = this;

      var dto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var contentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'application/json';

      return this._http.patch(url, dto, { headers: { 'Content-Type': contentType } }).then(function (res) {
        if (res.ok) {
          return res;
        } else {
          return false;
        }
      }, function (err) {
        return _this5.errorHandler(err);
      });
    }
  }, {
    key: 'customDelete',
    value: function customDelete(url) {
      var _this6 = this;

      var dto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var contentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'application/json';

      _vue2.default.http.headers.common['Content-Type'] = contentType;
      return this._http.delete(url, dto, { headers: { 'Content-Type': contentType } }).then(function (res) {
        if (res.ok) {
          return res;
        } else {
          return false;
        }
      }, function (err) {
        return _this6.errorHandler(err);
      });
    }
  }, {
    key: 'baseUrl',
    get: function get() {
      return API;
    }
  }]);

  return InfoService;
}();

exports.default = InfoService;

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 177:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 178:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 179:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 180:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 181:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 182:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(177)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(204),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(205),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(179)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(207),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(180)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(208),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(178)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(206),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-69f1a710",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(182)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(210),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e9b7e9fc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "corpo",
    attrs: {
      "id": "app"
    }
  }, [_c('dap-header'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "pagina"
  }, [_c('transition', {
    attrs: {
      "name": "pagina"
    }
  }, [_c('router-view')], 1)], 1)]), _vm._v(" "), _c('dap-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid rtl"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container-fluid addSomePadding"
  }, [_c('div', {
    staticClass: "col-md-12 table-responsive"
  }, [_c('table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_c('router-link', {
      attrs: {
        "to": '/category/' + item.id
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.edit(item)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("\n                   \n\n\n                  "), _c('a', {
      staticClass: "text-danger",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.remove(item.id)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-remove",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-12",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.callList
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.add({
          id: 0,
          name: ''
        })
      }
    }
  }, [_vm._v("הוסף פרוייקט")])])])])]), _vm._v(" "), (_vm.obj != null) ? _c('div', {
    staticClass: "popupForm"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title",
    domProps: {
      "textContent": _vm._s(_vm.addEditTitle)
    }
  }, [_vm._v("Save Category")])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid addSomePadding"
  }, [_c('div-vali', {
    staticClass: "col-md-12",
    attrs: {
      "errorVee": _vm.errors.has('name'),
      "labelTxt": "שם פרויקט"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.name),
      expression: "obj.name"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "data-vv-rules": "required"
    },
    domProps: {
      "value": (_vm.obj.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel()
      }
    }
  }, [_vm._v("ביטול")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("שמור")])])], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title rtl"
  }, [_vm._v("רשימת פרויקטים")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("שם הפרויקט")]), _vm._v(" "), _c('th', [_vm._v("כלים")])])])
}]}

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notPage",
    attrs: {
      "id": "page"
    }
  }, [_c('popup', {
    staticClass: "login middle center rtl"
  }, [_c('h1', [_vm._v("התחבר למערכת")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login),
      expression: "login"
    }],
    staticClass: "ltr",
    attrs: {
      "type": "text",
      "name": "login",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.login)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "ltr",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (false) ? _c('span', {
    staticClass: "center errorMessage colorDanger"
  }, [_vm._v("שגיאה, אימייל ו/או סיסמא לא נכונים")]) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.signin()
      }
    }
  }, [_vm._v("התחבר")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (false) ? _c('footer', {
    staticClass: "footer"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Copyright © Studio Metatron Ltd.")])])
}]}

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('h1', [_vm._v("רשימת פרוייקטים")]), _vm._v(" "), _c('table', {
    staticClass: "center rtl tableWithTools",
    attrs: {
      "align": "center",
      "cellpadding": "10",
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("שם "), _c('span', {
    staticClass: "oi",
    attrs: {
      "data-glyph": "arrow-bottom"
    }
  }), _c('span', {
    staticClass: "oi",
    attrs: {
      "data-glyph": "arrow-top"
    }
  })]), _vm._v(" "), _c('th', [_vm._v("כלים")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "oi colorLink isLink",
    attrs: {
      "data-glyph": "link-intact"
    }
  }), _vm._v(" בדיקה אחת שתיים שלוש")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "oi colorWarning isLink",
    attrs: {
      "data-glyph": "pencil"
    }
  }), _vm._v("   "), _c('span', {
    staticClass: "oi colorDanger isLink",
    attrs: {
      "data-glyph": "trash"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "oi colorLink isLink",
    attrs: {
      "data-glyph": "link-intact"
    }
  }), _vm._v(" בדיקה אחת שתיים שלוש")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "oi colorWarning isLink",
    attrs: {
      "data-glyph": "pencil"
    }
  }), _vm._v("   "), _c('span', {
    staticClass: "oi colorDanger isLink",
    attrs: {
      "data-glyph": "trash"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "oi colorLink isLink",
    attrs: {
      "data-glyph": "link-intact"
    }
  }), _vm._v(" בדיקה אחת שתיים שלוש")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "oi colorWarning isLink",
    attrs: {
      "data-glyph": "pencil"
    }
  }), _vm._v("   "), _c('span', {
    staticClass: "oi colorDanger isLink",
    attrs: {
      "data-glyph": "trash"
    }
  })])])])])])
}]}

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid rtl"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title rtl"
  }, [_vm._v("סרטים לפרויקט \"" + _vm._s(_vm.category.name) + "\"")])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "search",
      "placeholder": "חפש"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        return _vm.callList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 table-responsive addSomePadding"
  }, [_c('table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.ceil(item.total_words / 250)))]), _vm._v(" "), _c('td', {
      staticClass: "nowarp"
    }, [_c('button', {
      staticClass: "downloadButton",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadJson(item.id, item.name, 'txtspk')
        }
      }
    }, [_vm._v("Avid Speakers")]), _vm._v(" "), _c('button', {
      staticClass: "downloadButton",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadJson(item.id, item.name, 'txt')
        }
      }
    }, [_vm._v("Avid Locators")]), _vm._v(" "), _c('button', {
      staticClass: "downloadButton",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadJson(item.id, item.name, 'txtsrt')
        }
      }
    }, [_vm._v("Avid Subcap")]), _vm._v(" "), _c('button', {
      staticClass: "downloadButton",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadJson(item.id, item.name, 'srt')
        }
      }
    }, [_vm._v("SRT")]), _vm._v(" "), _c('button', {
      staticClass: "downloadButton",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadJson(item.id, item.name, 'docx')
        }
      }
    }, [_vm._v("Word")]), _vm._v(" "), _c('button', {
      staticClass: "downloadButton",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadJson(item.id, item.name, 'odt')
        }
      }
    }, [_vm._v("OpenOffice")])]), _vm._v(" "), _c('td', {
      staticClass: "nowarp"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.edit(item)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("\n                   \n                  "), _c('a', {
      staticClass: "text-danger",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.remove(item.id)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-remove",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-12",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.callList
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push({
          name: 'home'
        })
      }
    }
  }, [_vm._v("חזור לפרוייקטים")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.add({
          id: 0,
          name: '',
          interviewer: ''
        })
      }
    }
  }, [_vm._v("הוסף סרט")])])])])]), _vm._v(" "), (_vm.obj != null) ? _c('div', {
    staticClass: "popupForm"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title",
    domProps: {
      "textContent": _vm._s(_vm.addEditTitle)
    }
  }, [_vm._v("Save Video")])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid addSomePadding"
  }, [_c('div-vali', {
    staticClass: "col-md-12 rtl",
    attrs: {
      "errorVee": _vm.errors.has('file'),
      "labelTxt": "קובץ JSON"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.getFileRequired()),
      expression: "getFileRequired()"
    }],
    ref: "file",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "file"
    },
    on: {
      "change": function($event) {
        return _vm.handleFileUpload()
      }
    }
  })]), _vm._v(" "), _c('div-vali', {
    staticClass: "col-md-12",
    attrs: {
      "errorVee": _vm.errors.has('name'),
      "labelTxt": "שם סרט"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.name),
      expression: "obj.name"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "data-vv-rules": "required"
    },
    domProps: {
      "value": (_vm.obj.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div-vali', {
    staticClass: "col-md-12",
    attrs: {
      "errorVee": _vm.errors.has('interviewer'),
      "labelTxt": "מרואיין"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.interviewer),
      expression: "obj.interviewer"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "interviewer",
      "data-vv-rules": "required"
    },
    domProps: {
      "value": (_vm.obj.interviewer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj, "interviewer", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel()
      }
    }
  }, [_vm._v("בטל")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("שמור")])])], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("שם")]), _vm._v(" "), _c('th', [_vm._v("מילים")]), _vm._v(" "), _c('th', [_vm._v("הורד")]), _vm._v(" "), _c('th', [_vm._v("כלים")])])])
}]}

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.getClassValue()
  }, [(_vm.labelTxt) ? _c('label', [_vm._v(_vm._s(_vm.labelTxt))]) : _vm._e(), _vm._v(" "), (_vm.errorVee && _vm.labelTxt) ? _c('span', {
    staticClass: "glyphicon glyphicon-info-sign text-danger",
    attrs: {
      "aria-hidden": "true",
      "data-placement": "top",
      "title": _vm.errorMsg
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.errorVee && !_vm.labelTxt) ? _c('span', {
    staticClass: "glyphicon glyphicon-info-sign text-danger",
    attrs: {
      "aria-hidden": "true",
      "data-placement": "top",
      "title": _vm.errorMsg
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 210:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auth.authenticated),
      expression: "auth.authenticated"
    }]
  }, [_c('nav', {
    staticClass: "navbar navbar-default",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [(_vm.auth.authenticated) ? _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/category"
    }
  }, [_vm._v("פרויקטים")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.auth.authenticated) ? _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown rtl",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.signout
    }
  }, [_vm._v("התנתק")])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand rtl",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("ניהול OCD")])], 1) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "caret"
  })])
}]}

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.auth = exports.bus = undefined;

__webpack_require__(83);

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(88);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(54);

var _router2 = _interopRequireDefault(_router);

var _vueResource = __webpack_require__(90);

var _vueResource2 = _interopRequireDefault(_vueResource);

var _veeValidate = __webpack_require__(87);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _vMask = __webpack_require__(85);

var _vMask2 = _interopRequireDefault(_vMask);

var _auth = __webpack_require__(79);

var _auth2 = _interopRequireDefault(_auth);

var _bus = __webpack_require__(80);

var _bus2 = _interopRequireDefault(_bus);

var _vueResourceMock = __webpack_require__(89);

var _vueResourceMock2 = _interopRequireDefault(_vueResourceMock);

var _mockdata = __webpack_require__(78);

var _mockdata2 = _interopRequireDefault(_mockdata);

var _elementUi = __webpack_require__(55);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(84);

var _ptBr = __webpack_require__(82);

var _ptBr2 = _interopRequireDefault(_ptBr);

var _locale = __webpack_require__(18);

var _locale2 = _interopRequireDefault(_locale);

__webpack_require__(81);

var _pt_BR = __webpack_require__(86);

var _pt_BR2 = _interopRequireDefault(_pt_BR);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false; // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


_vue2.default.use(_vueResource2.default);
_vue2.default.use(_veeValidate2.default);
_vue2.default.use(_vMask2.default);

if (false) {
  _vue2.default.use(_vueResourceMock2.default, _mockdata2.default /* { silent: true/false } */);
}

_locale2.default.use(_ptBr2.default);
_vue2.default.use(_elementUi2.default);
_veeValidate.Validator.localize('pt_BR', _pt_BR2.default);

var bus = exports.bus = new _bus2.default();
var auth = exports.auth = new _auth2.default(_router2.default);

_router2.default.beforeEach(function (to, from, next) {
  if (!auth.initialized) {
    auth.saveForward(next, to);
  } else if (to.meta.auth && !auth.authenticated) {
    auth.saveForward(next, to);
    _router2.default.push({
      path: 'login'
    });
  } else {
    next();
  }
});

/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  components: {
    App: _App2.default
  }
});

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable */


var _elementUi = __webpack_require__(55);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Utils = function () {
    function Utils() {
        _classCallCheck(this, Utils);
    }

    _createClass(Utils, null, [{
        key: 'getBaseUrl',
        value: function getBaseUrl() {
            return "//ocdpost.metatron.co.il/index.php/api/" + 'v1/';
        }
    }, {
        key: 'getCaptchaCode',
        value: function getCaptchaCode() {
            return __webpack_require__.i({"NODE_ENV":"production","API":"//ocdpost.metatron.co.il/index.php/api/","MOCK_SERVER":false}).CAPTCHA_CODE;
        }
    }, {
        key: 'getFile',
        value: function getFile(response) {
            var result = document.createElement('a');
            var contentDisposition = response.headers.get('Content-Disposition') || '';
            var filename = contentDisposition.split('filename=')[1];
            filename = filename.replace(/"/g, "");

            return response.blob().then(function (data) {
                result.href = window.URL.createObjectURL(data);
                result.target = '_self';
                result.download = filename;

                return result;
            });
        }
    }, {
        key: 'showMessage',
        value: function showMessage(msg, tipo) {
            var close = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (tipo) {
                (0, _elementUi.Message)({
                    showClose: close,
                    message: msg,
                    type: tipo,
                    center: true
                });
            } else {
                (0, _elementUi.Message)({
                    showClose: close,
                    message: msg,
                    center: true
                });
            }
        }
    }, {
        key: 'geracor',
        value: function geracor() {
            var quantidade = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            var retorno = [];
            for (var j = 0; j < quantidade; j++) {
                var hexadecimais = '0123456789ABCDEF';
                var cor = '#';

                // Pega um número aleatório no array acima
                for (var i = 0; i < 6; i++) {
                    //E concatena à variável cor
                    cor += hexadecimais[Math.floor(Math.random() * 16)];
                    if (retorno.indexOf(cor) != -1) {
                        j--;
                    }
                }
                retorno.push(cor);
            }
            return retorno;
        }
    }]);

    return Utils;
}();

exports.default = Utils;

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(212);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Login = __webpack_require__(198);

var _Login2 = _interopRequireDefault(_Login);

var _Principal = __webpack_require__(199);

var _Principal2 = _interopRequireDefault(_Principal);

var _Category = __webpack_require__(197);

var _Category2 = _interopRequireDefault(_Category);

var _Video = __webpack_require__(200);

var _Video2 = _interopRequireDefault(_Video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: '/login',
    name: 'login',
    component: _Login2.default,
    meta: {
      auth: false
    }
  }, {
    path: '',
    name: 'home',
    redirect: {
      name: 'category'
    },
    meta: {
      auth: true
    }
  }, {
    path: '/category',
    name: 'category',
    component: _Category2.default,
    meta: {
      auth: true
    }
  }, {
    path: '/category/:id',
    component: _Video2.default,
    meta: {
      auth: true
    }
  }]
});

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _InfoService2 = __webpack_require__(123);

var _InfoService3 = _interopRequireDefault(_InfoService2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BasicoService = function (_InfoService) {
  _inherits(BasicoService, _InfoService);

  function BasicoService(ref) {
    _classCallCheck(this, BasicoService);

    return _possibleConstructorReturn(this, (BasicoService.__proto__ || Object.getPrototypeOf(BasicoService)).call(this, ref));
  }

  _createClass(BasicoService, [{
    key: 'category',
    value: function category(id) {
      var url = _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'baseUrl', this) + 'category/' + id;
      return _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'customGet', this).call(this, url);
    }
  }, {
    key: 'categoryList',
    value: function categoryList(page) {
      var url = _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'baseUrl', this) + 'category';
      var params = {
        page: page
      };
      return _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'customGet', this).call(this, url, params);
    }
  }, {
    key: 'categorySave',
    value: function categorySave(dto) {
      var url = '';
      if (dto.id > 0) {
        url = _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'baseUrl', this) + 'category/' + dto.id;
      } else {
        url = _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'baseUrl', this) + 'category';
      }
      return _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'customPut', this).call(this, url, dto);
    }
  }, {
    key: 'categoryDelete',
    value: function categoryDelete(id) {
      var url = _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'baseUrl', this) + 'category/' + id;
      return _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'customDelete', this).call(this, url);
    }
  }, {
    key: 'videoList',
    value: function videoList(id, name, page) {
      var url = _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'baseUrl', this) + 'video';
      var params = {
        page: page,
        category_id: id,
        name: name
      };
      return _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'customGet', this).call(this, url, params);
    }
  }, {
    key: 'videoSave',
    value: function videoSave(videoId, dto) {
      var url = '';
      if (videoId > 0) {
        url = _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'baseUrl', this) + 'video/' + videoId;
      } else {
        url = _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'baseUrl', this) + 'video';
      }
      return _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'customPost', this).call(this, url, dto, 'multipart/form-data');
    }
  }, {
    key: 'videoDelete',
    value: function videoDelete(id) {
      var url = _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'baseUrl', this) + 'video/' + id;
      return _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'customDelete', this).call(this, url);
    }
  }, {
    key: 'videoExport',
    value: function videoExport(id, type) {
      var url = _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'baseUrl', this) + 'video/' + id + '/export/' + type;
      return _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'customGetDownload', this).call(this, url);
    }
  }, {
    key: 'getVideoExportUrl',
    value: function getVideoExportUrl(id, type) {
      return _get(BasicoService.prototype.__proto__ || Object.getPrototypeOf(BasicoService.prototype), 'baseUrl', this) + 'video/' + id + '/export/' + type;
    }
  }]);

  return BasicoService;
}(_InfoService3.default);

exports.default = BasicoService;

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(209),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c93561e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({});


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable */


var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _User = __webpack_require__(121);

var _User2 = _interopRequireDefault(_User);

var _vueLs = __webpack_require__(211);

var _vueLs2 = _interopRequireDefault(_vueLs);

var _Utils = __webpack_require__(31);

var _Utils2 = _interopRequireDefault(_Utils);

var _jwtDecode = __webpack_require__(186);

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

_vue2.default.use(_vueLs2.default);

var Auth = function () {
  function Auth(router) {
    _classCallCheck(this, Auth);

    this._initialized = false;
    this._authenticated = false;
    this._user = null;
    this._next = null;
    this._to = null;
    this._router = router;

    this.createAddAuthorizationInterceptor();
  }

  _createClass(Auth, [{
    key: 'saveForward',
    value: function saveForward(next, to) {
      this._next = next;
      this._to = to;
    }
  }, {
    key: 'killForward',
    value: function killForward() {
      this._next = null;
      this._to = null;
    }
  }, {
    key: 'forward',
    value: function forward() {
      if (this._next !== null) {
        if (this._to.name == "home" || this._to.name == "login") {
          this._next({
            path: '/'
          });
        } else {
          this._next({
            path: this._router.path
          });
        }
        this.killForward();
      } else {
        this._next({
          path: '/'
        });
      }
    }
  }, {
    key: 'openLogin',
    value: function openLogin() {
      this._router.push({
        path: 'login'
      });
    }
  }, {
    key: 'check',
    value: function check() {
      var token = _vue2.default.ls.get('token');
      if (token) {
        this.readUserFromToken(token);
        if (!this._initialized) {
          this._initialized = true;
          this.forward();
        }
      } else {
        if (!this._initialized) {
          this._initialized = true;
          this.forward();
        }
        this.signout('', 'error');
      }
    }
  }, {
    key: 'createAddAuthorizationInterceptor',
    value: function createAddAuthorizationInterceptor() {
      var _this = this;

      _vue2.default.http.interceptors.push(function (request, next) {
        if (_this._authenticated) {
          var token = _vue2.default.ls.get('token');
          if (token) {
            request.headers.set('Authorization', 'Bearer ' + token);
          }
        }
        next();
      });
    }
  }, {
    key: 'proccessTokens',
    value: function proccessTokens(token) {
      this.limparAuth();
      this.readUserFromToken(token);

      var tokenDecoded = (0, _jwtDecode2.default)(token);
      _vue2.default.ls.set('token', token, this.getTokenDuration(tokenDecoded));
    }
  }, {
    key: 'readUserFromToken',
    value: function readUserFromToken(token) {
      var tokenDecoded = (0, _jwtDecode2.default)(token);
      if (tokenDecoded.sub) {
        this._authenticated = true;
        this._user = new _User2.default(tokenDecoded.sub);
      } else {
        this._authenticated = false;
        this._user = null;
      }
    }

    //retorna duration em milisegundos

  }, {
    key: 'getTokenDuration',
    value: function getTokenDuration(token) {
      return 86400000;
      //return (token.exp - token.iat) * 1000
    }
  }, {
    key: 'signin',
    value: function signin(username, password) {
      var _this2 = this;

      var login = username.toLowerCase();
      var data = 'email=' + login + '&password=' + password;
      _vue2.default.http.post("//ocdpost.metatron.co.il/index.php/api/" + 'login', data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        if (response.ok && response.status === 200) {
          _this2.proccessTokens(response.data.token);
          _Utils2.default.showMessage('Logged in', 'success');
          _this2._router.push({
            name: 'home'
          });
        } else {
          _Utils2.default.showMessage('Error on login', 'error');
        }
      }).catch(function () {
        _Utils2.default.showMessage('Error on login', 'error');
      });
    }
  }, {
    key: 'signout',
    value: function signout() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      this.limparAuth();
      if (msg != '') {
        _Utils2.default.showMessage(msg, type);
      }
      this.openLogin();
    }
  }, {
    key: 'limparAuth',
    value: function limparAuth() {
      _vue2.default.ls.clear();
      this._authenticated = false;
      this._user = null;
    }
  }, {
    key: 'initialized',
    get: function get() {
      return this._initialized;
    }
  }, {
    key: 'authenticated',
    get: function get() {
      return this._authenticated;
    }
  }, {
    key: 'user',
    get: function get() {
      return this._user;
    }
  }]);

  return Auth;
}();

exports.default = Auth;

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Bus = function () {
    function Bus() {
        _classCallCheck(this, Bus);

        this._bus = new _vue2.default();
    }

    _createClass(Bus, [{
        key: 'listener',
        value: function listener(event, callback) {
            return this._bus.$on(event, callback);
        }
    }, {
        key: 'dispatchEvent',
        value: function dispatchEvent(event, obj) {
            this._bus.$emit(event, obj);
        }
    }]);

    return Bus;
}();

exports.default = Bus;

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(176)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(203),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[30]);


// WEBPACK FOOTER //
// static/js/app.227b9d20f093afd6093a.js